<div class = "reusable-form-component">
    <ion-label *ngIf = "labelText" class = "label labelText">{{ labelText }}</ion-label>
    <button class="position select-font" (click) = "handleSubSkillDropDownClick()" [ngClass] = "{'placeholder' : placeHolderText == 'Select Sub Skill'}">{{ placeHolderText }}      
</button>

    <!-- Multi-select values as removable chips. A comma-joined string could
         only be edited by reopening the picker and hunting for the entry. -->
    <div class="chips" *ngIf="chips.length">
      <span class="chip" *ngFor="let option of chips">
        <span class="chip-text">{{ option }}</span>
        <button type="button" class="chip-remove" [attr.aria-label]="'Remove ' + option"
                (click)="removeOption(option, $event)">
          <i class="fas fa-times"></i>
        </button>
      </span>
    </div>
